import { render, staticRenderFns } from "./OrderInfoNotes.vue?vue&type=template&id=6fccbbf0&"
import script from "./OrderInfoNotes.vue?vue&type=script&lang=ts&"
export * from "./OrderInfoNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports